export const getFullApiUrl = (): string => {
    return "/api"
}
